import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'

var instance = axios.create({
    //headers: {'Content-type': 'application/x-www-form-urlencoded'},
    transformRequest: [function (data, headers) {
        // Do whatever you want to transform the data
        return qs.stringify(data)
    }]
})

Vue.prototype.$axios = instance